import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CustomToastContainer } from "./components/CustomToast";
import 'react-toastify/dist/ReactToastify.css';
import Home from "./Pages/Home";
import Layout from "./layout";
import Register from "./Pages/Register";
import ScrollToTopButton from "./components/ScrollToTop";

function App() {
  return (
    <>
      <CustomToastContainer />
      <Router>
        <ScrollToTopButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/register/:type" element={<Register />} />
          </Route>
        </Routes>
      </Router>
    </>
  )
}

export default App
